import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance, directClone } from 'intact-vue';
import { CarouselItem } from './item';
import { eachChildren, isComponentVNode } from '../utils';
import { isNullOrUndefined } from 'intact-shared';
export function useItems() {
  var instance = useInstance();
  var items = [];
  var itemsWithCloned = [];
  function handleChildren() {
    var _instance$get = instance.get(),
      children = _instance$get.children,
      value = _instance$get.value;
    items = [];
    itemsWithCloned = [];
    var index = 0;
    var valueExist = false;
    eachChildren(children, function (vNode) {
      if (isComponentVNode(vNode, CarouselItem)) {
        var clonedVNode = directClone(vNode);
        var props = _extends({}, vNode.props);
        if (isNullOrUndefined(props.value)) {
          props.value = "$" + index++;
        }
        if (isNullOrUndefined(props.key)) {
          props.key = props.value;
        }
        clonedVNode.props = props;
        items.push(clonedVNode);
        itemsWithCloned.push(clonedVNode);
        if (value === props.value) {
          valueExist = true;
        }
      }
    });
    if (!valueExist && items.length) {
      instance.set('value', items[0].props.value);
    }
    cloneVNodes();
  }
  function cloneVNodes() {
    if (instance.get('effect') === 'slide') {
      var _itemsWithCloned, _itemsWithCloned2;
      var length = itemsWithCloned.length;
      if (!length) return;
      // clone the first and last vNodes for loop
      var firstVNodes = [];
      var lastVNodes = [];
      var clone = function clone(vNode, index) {
        var clonedVNode = directClone(vNode);
        var props = clonedVNode.props;
        clonedVNode.props = _extends({}, props, {
          key: "$cloned:" + props.key + ":" + index,
          cloned: true
        });
        return clonedVNode;
      };
      for (var i = 0; i < instance.get('clonedAmount'); i++) {
        firstVNodes.push(clone(items[i % length], i));
        lastVNodes.unshift(clone(items[((length - i - 1) % length + length) % length], i));
      }
      (_itemsWithCloned = itemsWithCloned).push.apply(_itemsWithCloned, firstVNodes);
      (_itemsWithCloned2 = itemsWithCloned).unshift.apply(_itemsWithCloned2, lastVNodes);
    }
  }
  instance.on('$receive:children', handleChildren);
  return {
    getItems: function getItems() {
      return items;
    },
    getItemsWithCloned: function getItemsWithCloned() {
      return itemsWithCloned;
    }
  };
}